export default __webpack_public_path__ + "assets/instagram.63b70d18.svg";